export default __webpack_public_path__ + "static/media/usuarios.a29c7c07.csv";